<script>
export default {
	components: {},
	props : {
		lg : {
			type : String,
			required : false,
			default : ''
		},
		md : {
			type : String,
			required : false,
			default : ''
		},
		sm : {
			type : String,
			required : false,
			default : ''
		},
		xs : {
			type : String,
			required : false,
			default : ''
		},
	},
	computed : {
		getClass() {
			const ret = {};
			if(this.lg) {
				ret['col-lg-' + this.lg] = true;
			}
			if(this.md) {
				ret['col-md-' + this.md] = true;
			}
			if(this.sm) {
				ret['col-sm-' + this.sm] = true;
			}
			if(this.xs) {
				ret['col-xs-' + this.xs] = true;
			}
			
			return ret;
		}
	}
}
</script>

<template>
  <div class="col" :class="getClass">
		<slot></slot>
  </div>
</template>
